import CustomLink from 'components/CustomLink/CustomLink';
import { translate } from 'components/Translation';
import React from 'react';

const MoreDetails = () => {
	return (
		<CustomLink type="bodyMBold" to="/dashboard/users" color="brand">
			<>{translate('organization.details.more.details')}</>
		</CustomLink>
	);
};

export default MoreDetails;
